/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const createInstancesBodyContainsMax = 200;

export const createInstancesBodyIncludesMax = 200;

export const createInstancesBodyNodesItemClientIdMax = 36;

export const createInstancesBodyNodesItemClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const createInstancesBodyNodesMax = 100;

export const createInstancesBodyRelatesToMax = 200;

export const CreateInstancesBody = zod.object({
  contains: zod
    .array(
      zod.object({
        edgeDescription: zod
          .string()
          .nullish()
          .describe(
            'Free-text description of the edge, stored verbatim. Omit to keep the stored description of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); a NEW attachment that omits it stores none. null clears it.',
          ),
        edgeKey: zod
          .string()
          .nullish()
          .describe(
            'Schema field key (lower snake_case, letter first) for a CONTAINS\/INCLUDES edge between TYPEs. Omit to keep the stored key of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); only a NEW attachment that omits it derives the key from the target type name. null is rejected on CONTAINS\/INCLUDES on both commands (a schema field always has a key) and clears the key on RELATES_TO.',
          ),
        from: zod
          .string()
          .min(1)
          .optional()
          .describe(
            'Source node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. When omitted it defaults to the root (first) node on create, and to the TYPE being updated on PATCH \/types\/{uuid}.',
          ),
        max: zod.int().nullish().describe('Maximum cardinality (lowered to the edge maxCount).'),
        min: zod.int().nullish().describe('Minimum cardinality (lowered to the edge minCount).'),
        position: zod.int().nullish(),
        to: zod
          .string()
          .min(1)
          .describe(
            'Target node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. A PATCH carries no nodes, so there it is always an existing UUID.',
          ),
      }),
    )
    .max(createInstancesBodyContainsMax)
    .optional(),
  includes: zod
    .array(
      zod.object({
        edgeDescription: zod
          .string()
          .nullish()
          .describe(
            'Free-text description of the edge, stored verbatim. Omit to keep the stored description of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); a NEW attachment that omits it stores none. null clears it.',
          ),
        edgeKey: zod
          .string()
          .nullish()
          .describe(
            'Schema field key (lower snake_case, letter first) for a CONTAINS\/INCLUDES edge between TYPEs. Omit to keep the stored key of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); only a NEW attachment that omits it derives the key from the target type name. null is rejected on CONTAINS\/INCLUDES on both commands (a schema field always has a key) and clears the key on RELATES_TO.',
          ),
        from: zod
          .string()
          .min(1)
          .optional()
          .describe(
            'Source node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. When omitted it defaults to the root (first) node on create, and to the TYPE being updated on PATCH \/types\/{uuid}.',
          ),
        max: zod.int().nullish().describe('Maximum cardinality (lowered to the edge maxCount).'),
        min: zod.int().nullish().describe('Minimum cardinality (lowered to the edge minCount).'),
        position: zod.int().nullish(),
        to: zod
          .string()
          .min(1)
          .describe(
            'Target node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. A PATCH carries no nodes, so there it is always an existing UUID.',
          ),
      }),
    )
    .max(createInstancesBodyIncludesMax)
    .optional(),
  nodes: zod
    .array(
      zod.object({
        clientId: zod
          .string()
          .min(1)
          .max(createInstancesBodyNodesItemClientIdMax)
          .regex(createInstancesBodyNodesItemClientIdRegExp)
          .describe(
            'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
          ),
        contentTypeUuid: zod
          .uuid()
          .describe('UUID of the content TYPE this instance is an instance of.'),
        occurredAt: zod
          .string()
          .optional()
          .describe('ISO date-time the instance datum occurred at.'),
        subjectUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        value: zod
          .object({
            booleanValue: zod.boolean().nullish(),
            dateValue: zod.string().nullish(),
            datetimeValue: zod.string().nullish(),
            jsonValue: zod.unknown().optional(),
            numericValue: zod.number().nullish(),
            stringValue: zod.string().nullish(),
          })
          .optional(),
      }),
    )
    .min(1)
    .max(createInstancesBodyNodesMax),
  performAs: zod
    .object({
      actorUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER']),
    })
    .optional(),
  relatesTo: zod
    .array(
      zod.object({
        edgeDescription: zod
          .string()
          .nullish()
          .describe(
            'Free-text description of the edge, stored verbatim. Omit to keep the stored description of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); a NEW attachment that omits it stores none. null clears it.',
          ),
        edgeKey: zod
          .string()
          .nullish()
          .describe(
            'Schema field key (lower snake_case, letter first) for a CONTAINS\/INCLUDES edge between TYPEs. Omit to keep the stored key of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); only a NEW attachment that omits it derives the key from the target type name. null is rejected on CONTAINS\/INCLUDES on both commands (a schema field always has a key) and clears the key on RELATES_TO.',
          ),
        from: zod
          .string()
          .min(1)
          .optional()
          .describe(
            'Source node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. When omitted it defaults to the root (first) node on create, and to the TYPE being updated on PATCH \/types\/{uuid}.',
          ),
        max: zod.int().nullish().describe('Maximum cardinality (lowered to the edge maxCount).'),
        min: zod.int().nullish().describe('Minimum cardinality (lowered to the edge minCount).'),
        position: zod.int().nullish(),
        to: zod
          .string()
          .min(1)
          .describe(
            'Target node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. A PATCH carries no nodes, so there it is always an existing UUID.',
          ),
      }),
    )
    .max(createInstancesBodyRelatesToMax)
    .optional(),
});

export type CreateInstancesBody = zod.input<typeof CreateInstancesBody>;
export type CreateInstancesBodyOutput = zod.output<typeof CreateInstancesBody>;
